import http from '@/utils/services/http'

export function findRetirada (id) {
  return http.get('/api/retirada/' + id)
    .then(response => {
      console.log(response)
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export default {
  list () {
    return http.get('/api/retirada/')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrar () {
    return http.post('/api/retirada/new')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (retirada, force = false, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(retirada, id)
    }
    return http.post(`/api/retirada${force ? '?force=true' : ''}`, retirada)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/retirada/' + id)
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  update (id) {
    return http.patch('/api/retirada/' + id + '/update')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  delete (id) {
    return http.delete('/api/retirada/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  verificarPendenciasVeiculo (grv, tipoDocumentoLiberador, documentoLiberador) {
    return http.get(`/api/retirada/grv/${grv}/consultar-pendencias-liberacao?tipoDocumentoLiberador=${tipoDocumentoLiberador}&documentoLiberador=${documentoLiberador}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/retirada/services/index.js